"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const R = tslib_1.__importStar(require("ramda"));
function mapPublicProfileResult(publicProfile) {
    const name = R.pathOr(undefined, ["name", "value"], publicProfile);
    const image = R.pathOr(undefined, ["image", "value"], publicProfile);
    const headline = R.pathOr(undefined, ["headline", "value"], publicProfile);
    const verified = false;
    return {
        name: name ? { value: name, verified } : undefined,
        image: image ? { url: image, verified } : undefined,
        headline: headline ? { value: headline, verified } : undefined,
    };
}
exports.default = {
    mapPublicProfileResult,
};
